module.exports = __webpack_public_path__ + "media/images/teams/LECCE-f8f6c8225f1ea46099efcfa242f819f3.png";